import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { Modal } from '../../../components';
import BotonNuevoComponent from '../../entidades/components/BotonNuevo';
import { checkRootAccess } from '../../modulos/modules.helpers';
import {
  getAllTiposServiciosAction,
  setActivoTiposServiciosAction,
} from './TiposServiciosAction';
import FormTiposServicios from './components/FormTiposServicios';
import ListadoTiposServicios from './components/ListadoTiposServicios';

const TiposServiciosView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const tiposServiciosStore = Redux.useSelector(
    (state) => state.tiposServicios
  );

  const loginStore = Redux.useSelector((state) => state.login);
  checkRootAccess(loginStore);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonNuevoComponent
          click={async () => {
            await setActivoTiposServiciosAction(dispatch, null);
            setOpenModalForm(true);
          }}
          azul
          mr={2}
        />
        {tiposServiciosStore.all.length > 0 ? (
          <BotonNuevoComponent
            click={async () => {
              await setActivoTiposServiciosAction(dispatch, null);
              await getAllTiposServiciosAction(
                dispatch
              );
            }}
            disabled={tiposServiciosStore.loadingGetAll}
            white
            text={
              tiposServiciosStore.loadingGetAll
                ? 'Actualizando...'
                : 'Actualizar'
            }
          />
        ) : null}
      </Grid>
      <Grid item md={12}>
        <ListadoTiposServicios
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <Modal
        id="modalFormTiposServicios"
        title={`${
          tiposServiciosStore.activo ? 'Editar' : 'Nuevo'
        } tipo de servicio`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {tiposServiciosStore.activo ? (
          <Typography variant="h6">
            {tiposServiciosStore.activo.nombres}{' '}
            {tiposServiciosStore.activo.apellidos}
          </Typography>
        ) : null}
        <FormTiposServicios
          activo={tiposServiciosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Modal>
    </Grid>
  );
};

export default TiposServiciosView;
